import { render } from "./LogoutHome.vue?vue&type=template&id=70d484fb"
import script from "./LogoutHome.vue?vue&type=script&lang=js"
export * from "./LogoutHome.vue?vue&type=script&lang=js"

import "./LogoutHome.vue?vue&type=style&index=0&id=70d484fb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__